/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";

const NavCardsSimpleSectionItem = (props) => {
    
    const item = props?.item;
    
    const guid = item?.guid;
    const nav_title = item?.nav_title;
    const banner_image = item?.banner_image;
    
    const img_url = banner_image?.image?.url;
    
    return (
        <Fragment>
            <div className='simplicity-nav-cards-simple-list-item'>
                <a href={`/composer/${guid}`}>
                    <div className="simplicity-nav-cards-simple-list-item-title">
                        <div className="simplicity-nav-cards-simple-card-image"
                            style={{
                                backgroundImage: `url(${img_url})`,
                            }}
                        ></div>
                        <div className="simplicity-nav-cards-simple-list-item-text">

                            <div className="simplicity-nav-cards-simple-title">
                                {nav_title}
                            </div>
                            
                        </div>
                    </div>
                </a>
            
            </div>
        </Fragment>
    );
};

export { NavCardsSimpleSectionItem }; 
